const hnJSON = {
  Tokyo: 'Muraqabah Pilgrimage portal',
  'Accent Sidebar': 'एक्सेंट साइडबार',
  'Tokyo White React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  'Tokyo React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  'Tokyo Black React Typescript Admin Dashboard':
    'Muraqabah Pilgrimage portal',
  '&copy; 2026 - Muraqabah Pilgrimage portal':
    '&copy; 2026 - Muraqabah Pilgrimage portal',
  'Muraqabah Pilgrimage portal': 'Muraqabah Pilgrimage portal',
  Dashboards: 'डैशबोर्ड',
  Dashboard: 'डैशबोर्ड',
  General: 'सामान्य',
  Roles: 'भूमिकाएँ',
  'Vendor Management': 'विक्रेता प्रबंधन',
  Vendors: 'विक्रेता',
  Package: 'पैकेज',
  Packages: 'पैकेज',
  Master: 'मास्टर',
  'Master Data': 'मास्टर डेटा',
  Master_Data_type: 'मास्टर डेटा प्रकार आवश्यक है',
  Inquiry: 'पूछताछ',
  'Inquiry Management': 'पूछताछ प्रबंधन',
  Inquiries: 'पूछताछ',
  'Service Management': 'सेवा प्रबंधन',
  'Business Profile': 'व्यापार प्रोफ़ाइल',
  your_analytics: 'आज के लिए ये आपके विश्लेषण सांख्यिकी हैं',
  Search_by_name: 'नाम, शॉर्टकोड या विवरण से खोजें...',
  Welcome: 'स्वागत है',
  'Active Referrals': 'सक्रिय संदर्भ',
  'See referring domains': 'रेफर करने वाले डोमेन देखें',
  'which sent most traffic': 'जिसने सबसे अधिक यातायात भेजा',
  'Pending Invitations': 'बकाया आमंत्रण',
  'Not opened yet': 'अभी तक नहीं खोला गया है',
  'See all invitations': 'सभी आमंत्रण देखें',
  'Sessions by Country': 'देश द्वारा सत्र',
  'Bounce Rate': 'बाउंस दर',
  'See all links': 'सभी लिंक देखें',
  'with high bounce rate.': 'उच्च बाउंस दर के साथ।',
  Conversion: 'परिवर्तन',
  'with the best conversion rates.': 'सर्वश्रेष्ठ परिवर्तन दर के साथ।',
  'See products': 'उत्पाद देखें',
  'Audience Overview': 'दर्शक अवलोकन',
  Today: 'आज',
  Yesterday: 'कल',
  'Last month': 'पिछले महीने',
  'Last year': 'पिछले साल',
  Users: 'उपयोगकर्ता',
  'New users': 'नए उपयोगकर्ता',
  'Page views': 'पृष्ठ दृश्य',
  'Avg. session duration': 'औसत सत्र अवधि',
  Sessions: 'सत्र',
  Conversions: 'परिवर्तन',
  'Sales Today': 'आज की बिक्री',
  'Customers per month': 'मासिक ग्राहक',
  'Earnings Report': 'कमाई की रिपोर्ट',
  'Top Landing Pages': 'शीर्ष लैंडिंग पेज',
  Impressions: 'प्रभाव',
  Clicks: 'क्लिक',
  'Visit URL': 'यूआरएल पर जाएं',
  'Traffic Sources': 'यातायात स्रोत',
  'Generate Chart': 'चार्ट उत्पन्न करें',
  'pages/session': 'पृष्ठ/सत्र',
  'New Sessions': 'नए सत्र',
  'User & Role Management': 'उपयोगकर्ता और भूमिका प्रबंधन',
  Management: 'प्रबंधन',
  user_can_be_managed: 'इस पृष्ठ से संबंधित सभी पहलु प्रबंधित किए जा सकते हैं',
  Add: 'जोड़ें',
  role_can_be_managed: 'इस पृष्ठ से संबंधित सभी पहलु प्रबंधित किए जा सकते हैं',
  Role_required: 'भूमिका का नाम आवश्यक है',
  'Add new role': 'नई भूमिका जोड़ें',
  'Edit role details': 'भूमिका विवरण संपादित करें',
  fields_new_role: 'नीचे दिए गए क्षेत्र भरें एक नई भूमिका जोड़ने के लिए।',
  'Role Name': 'भूमिका का नाम',
  'Short Code': 'शॉर्ट कोड',
  Description: 'विवरण',
  Cancel: 'रद्द करें',
  Save: 'सहेजें',
  Edit: 'संपादित करें',
  Url: 'यूआरएल',
  Delete: 'हटाएं',
  'Tour Itinerary': 'यात्रा कार्यक्रम',
  below_to_edit: 'भूमिका विवरण संपादित करने के लिए नीचे दिए गए क्षेत्र भरें।',
  Description_required: 'विवरण आवश्यक है',
  Short_Code_required: 'शॉर्ट कोड आवश्यक है',
  Special_Chars_not_allowed: 'विशेष चर और संख्याएं अनुमति नहीं हैं।',
  'Search by name, shortcode or description...':
    'नाम, शॉर्टकोड या विवरण से खोजें...',
  'Sr. No.': 'क्रमांक',
  Name: 'नाम',
  Shortcode: 'शॉर्टकोड',
  'Created By': 'द्वारा बनाया गया',
  'Modified By': 'द्वारा संशोधित',
  Actions: 'क्रियाएँ',
  'Loading...': 'लोड हो रहा है...',
  'No results found': 'कोई परिणाम नहीं मिला',
  'Advanced View': 'उन्नत दृश्य',
  'Assigned Roles': 'सौंपी गई भूमिकाएँ',
  Password: 'पासवर्ड',
  Email: 'ईमेल',
  'Last name': 'अंतिम नाम',
  'First name': 'पहला नाम',
  Airlines: 'एयरलाइंस',
  'Select room sharing': 'कमरे को शेयर करें',
  'Room Sharing': 'कमरे को शेयर करें',
  'Package Type': 'पैकेज प्रकार',
  'Select package type': 'पैकेज प्रकार चुनें',
  'Package Details': 'पैकेज विवरण',
  'Package Name': 'पैकेज का नाम',
  Departure: 'प्रस्थान',
  'Package Room Sharing': 'पैकेज के कमरे को शेयर करें',
  'Package Airline': 'पैकेज एयरलाइंस',
  'Package Amount': 'पैकेज राशि',
  'Package Inquiry Date': 'पैकेज पूछताछ तिथि',
  'Inquiry Date': 'पूछताछ तिथि',
  'Vendor Name': 'विक्रेता का नाम',
  'Phone Number': 'फोन नंबर',
  'Customer Email': 'ग्राहक ईमेल',
  'Customer Name': 'ग्राहक का नाम',
  Status: 'स्थिति',
  'Customer Phone No.': 'ग्राहक फोन नंबर',
  'Customer Phone Number': 'ग्राहक फोन नंबर',
  Search_by_customer_name:
    'ग्राहक के नाम, ईमेल, फोन नंबर, पैकेज प्रकार, नाम, कमरे को शेयर करें...',
  'Status Type': 'स्थिति प्रकार',
  'Select status type': 'स्थिति प्रकार चुनें',
  'NEW LEAD': 'नया लीड',
  'FOLLOW UP': 'फॉलो अप',
  CLOSED: 'बंद',
  'NOT INTERESTED': 'दिलचस्पी नहीं है',
  'NOT CONTACTED': 'संपर्क नहीं किया गया',
  'Room Sharing is required': 'कमरे को शेयर करना आवश्यक है',
  PACKAGE_TYPE: 'पैकेज प्रकार',
  AIRLINES_TYPE: 'एयरलाइंस प्रकार',
  ROOM_SHARING: 'कमरे को शेयर करना',
  INCLUSION_TYPE: 'समावेश प्रकार',
  EXCLUSION_TYPE: 'अपवाद प्रकार',
  An_error_occurred: 'मास्टर डेटा बनाते समय एक त्रुटि हुई',
  Master_Type: 'मास्टर डेटा प्रकार',
  'Select master data type': 'मास्टर डेटा प्रकार चुनें',
  Update: 'अपडेट',
  'End Date': 'समाप्ति तिथि',
  Search_by_master_data: 'नाम से खोजें...',
  Inclusions_and_Package: 'समावेश और पैकेज के मुख्य अंश',
  Exclusions: 'अपवाद',
  'Upload Images': 'छवियां अपलोड करें',
  Days: 'दिन',
  'From Date': 'से तारीख',
  'To Date': 'तक की तारीख',
  ID: 'आईडी',
  Search: 'खोजें',
  'Customer Lead': 'ग्राहक लीड',
  'Vendor Lead': 'विक्रेता लीड',
  'Customer Lead Details': 'ग्राहक लीड विवरण',
  'Vendor Lead Details': 'विक्रेता लीड विवरण',
  'Vendor List': 'विक्रेता सूची',
  'Lead Count': 'लीड गिनती',
  'Package Lead Count': 'पैकेज लीड गिनत',
  Position: 'स्थिति',
  'The bottom banner status has been updated':
    'निचले बैनर की स्थिति अपडेट की गई है',
  "Couldn't update bottom banner status":
    'निचले बैनर की स्थिति अपडेट नहीं की जा सकी',
  'The role account created successfully': 'भूमिका खाता सफलतापूर्वक बनाया गया',
  'Package Detail has been updated': 'पैकेज विवरण अपडेट किया गया है',
  'Error while saving package detail': 'पैकेज विवरण सहेजते समय त्रुटि',
  'Package detail saved successfully': 'पैकेज विवरण सफलतापूर्वक सहेजा गया',
  'Package Details approved successfully':
    'पैकेज विवरण सफलतापूर्वक मंजूरी प्राप्त हुई',
  'Error while approving Package Details': 'पैकेज विवरण मंजूरी देते समय त्रुटि',
  'Hotel Details approved successfully':
    'होटल विवरण सफलतापूर्वक मंजूरी प्राप्त हुई',
  'Error while approving Hotel Details': 'होटल विवरण मंजूरी देते समय त्रुटि',
  'Tour Itinerary approved successfully':
    'यात्रा योजना सफलतापूर्वक मंजूरी प्राप्त हुई',
  'Error while approving Tour Itinerary': 'यात्रा योजना मंजूरी देते समय त्रुटि',
  'Error while approving Inclusions': 'समावेश मंजूरी देते समय त्रुटि',
  'Inclusions approved successfully': 'समावेश सफलतापूर्वक मंजूरी प्राप्त हुई',
  'Exclusions approved successfully': 'अपवाद सफलतापूर्वक मंजूरी प्राप्त हुई',
  'Error while approving Exclusions': 'अपवाद मंजूरी देते समय त्रुटि',
  'Comment Added Successfully': 'टिप्पणी सफलतापूर्वक जोड़ी गई',
  'The days are not specific to the provider dates':
    'दिन प्रदाता की तिथियों के अनुसार नहीं हैं',
  'Row saved successfully': 'पंक्ति सफलतापूर्वक सहेजी गई',
  'Row updated successfully': 'पंक्ति सफलतापूर्वक अपडेट की गई',
  'Row deleted successfully': 'पंक्ति सफलतापूर्वक हटा दी गई',
  'Row Saved Successfully': 'पंक्ति सफलतापूर्वक सहेजी गई',
  'Row has been updated': 'पंक्ति अपडेट की गई है',
  'Row Deleted Successfully': 'पंक्ति सफलतापूर्वक हटा दी गई',
  'An error occurred while creating the role': 'भूमिका बनाते समय एक त्रुटि आई',
  'Record has been updated': 'रिकॉर्ड अपडेट किया गया है',
  'Error while updating record': 'रिकॉर्ड अपडेट करते समय त्रुटि',
  'Remark has been saved successfully': 'टिप्पणी सफलतापूर्वक सहेजी गई',
  'Error while saving remark': 'टिप्पणी सहेजते समय त्रुटि',
  'Permissions has been updated': 'अनुमतियाँ अपडेट की गई हैं',
  'Package status has been updated': 'पैकेज स्थिति अपडेट की गई है',
  "Couldn't update package status": 'पैकेज स्थिति अपडेट नहीं की जा सकी',
  'Password successfully changed': 'पासवर्ड सफलतापूर्वक बदल गया है',
  'Image size is too large': 'चित्र का आकार बहुत बड़ा है',
  'The bottom banner created successfully': 'निचला बैनर सफलतापूर्वक बनाया गया',
  'The banner was updated successfully': 'बैनर सफलतापूर्वक अपडेट किया गया',
  'Role status has been updated': 'भूमिका स्थिति अपडेट की गई है',
  "Couldn't update role status": 'भूमिका स्थिति अपडेट नहीं की जा सकी',
  'The user account created successfully':
    'उपयोगकर्ता खाता सफलतापूर्वक बनाया गया',
  'User status has been updated': 'उपयोगकर्ता स्थिति अपडेट की गई है',
  "Couldn't update user status": 'उपयोगकर्ता स्थिति अपडेट नहीं की जा सकी',
  'The card has been removed successfully': 'कार्ड सफलतापूर्वक हटा दिया गया है',
  'Search by package name...': 'पैकेज के नाम से खोजें...',
  'Search by customer name or email...': 'ग्राहक के नाम या ईमेल से खोजें...',
  'Customer Details': 'ग्राहक विवरण',
  'Package Inquiry Status': 'पैकेज पूछताछ स्थिति',
  'Lead History': 'लीड इतिहास',
  'Search by description': 'विवरण से खोजें',
  'Top Banner': 'शीर्ष बैनर',
  'Bottom Banner': 'निचला बैनर',
  'Hajj/Umrah Package': 'हज/उमरा पैकेज',
  'Search by package name, package type or room sharing...':
    'पैकेज के नाम, पैकेज प्रकार या कमरे साझा करने से खोजें...',
  'Start Date': 'प्रारंभ तिथि',
  'Search by name or email...': 'नाम या ईमेल से खोजें...',
  'Search by customer name, email,phone no,package name,vendor name...':
    'ग्राहक के नाम, ईमेल, फोन नंबर, पैकेज का नाम, वेंडर के नाम से खोजें...',
  'Search by vendor name': 'वेंडर के नाम से खोजें',
  'Total Package Count': 'कुल पैकेज की संख्या',
  'Total Lead Count': 'कुल लीड की संख्या',
  'Banner Management': 'बैनर प्रबंधन',
  Banner: 'बैनर',
  'Banner Top': 'शीर्ष बैनर',
  'Banner Bottom': 'निचला बैनर',
  Active: 'सक्रिय',
  Inactive: 'निष्क्रिय',
  'Lead Management': 'लीड प्रबंधन',
  Lead: 'लीड',
  'Are you sure you want to Activate this package?':
    'क्या आप इस पैकेज को सक्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this package':
    'क्या आप इस पैकेज को निष्क्रिय करना चाहते हैं?',
  Activate: 'सक्रिय करें',
  'In-Activate': 'निष्क्रिय करें',
  'Are you sure you want to Activate this banner?':
    'क्या आप इस बैनर को सक्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this banner?':
    'क्या आप इस बैनर को निष्क्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this role?':
    'क्या आप इस भूमिका को निष्क्रिय करना चाहते हैं?',
  'Are you sure you want to Activate this role?':
    'क्या आप इस भूमिका को सक्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this user':
    'क्या आप इस उपयोगकर्ता को निष्क्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this user?':
    'क्या आप इस उपयोगकर्ता को निष्क्रिय करना चाहते हैं?',
  'Are you sure you want to Activate this user?':
    'क्या आप इस उपयोगकर्ता को सक्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this master data?':
    'क्या आप इस मास्टर डेटा को निष्क्रिय करना चाहते हैं?',
  'Are you sure you want to Activate this master data?':
    'क्या आप इस मास्टर डेटा को सक्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this vendor?':
    'क्या आप इस विक्रेता को निष्क्रिय करना चाहते हैं?',
  'Are you sure you want to Activate this vendor?':
    'क्या आप इस विक्रेता को सक्रिय करना चाहते हैं?',
  'Type of Tours Provided': 'प्रदान किए गए यात्रा प्रकार',
  Haj: 'हज',
  Umrah: 'उमराह',
  Ziyarat: 'जियारत',
  Pincode: 'पिनकोड',
  Country: 'देश',
  State: 'राज्य',
  'Select City': 'शहर चुनें',
  Landmark: 'सीमा-चिन्ह',
  Area: 'क्षेत्र',
  'Unit, Block, Wing, Building Name': 'इकाई, ब्लॉक, पंख्त, इमारत का नाम',
  'Street Name': 'सड़क का नाम',
  Address: 'पता',
  'Business Description': 'व्यापार विवरण',
  'Uploading...': 'अपलोड हो रहा है...',
  'Upload Company Logo': 'कंपनी का लोगो अपलोड करें',
  'Company Logo': 'कंपनी का लोगो',
  'Mobile Number': 'मोबाइल नंबर',
  'Mobile No.': 'मोबाइल नं.',
  'Email Address': 'ईमेल पता',
  'Year of Establishment': 'स्थापना का वर्ष',
  'Business Name': 'व्यापार का नाम',
  'Account & Business Information': 'खाता और व्यापार सूचना',
  Cheque: 'चेक',
  'Credit Card': 'क्रेडिट कार्ड',
  'Debit Card': 'डेबिट कार्ड',
  Cash: 'नकद',
  UPI: 'UPI',
  'Online Booking': 'ऑनलाइन बुकिंग',
  'Demand Draft': 'डिमांड ड्राफ्ट',
  'Payment Mode': 'भुगतान का माध्यम',
  'Member/Accredited/Authorised': 'सदस्य/मान्यता प्राप्त/अधिकृत',
  'IATA License': 'IATA लाइसेंस',
  'Upload IATA License': 'IATA लाइसेंस अपलोड करें',
  'Ministry of Tourism (GOI)': 'पर्यटन मंत्रालय (GOI)',
  'Allowed *.jpeg, *.jpg, *.png, *.pdf':
    '*.jpeg, *.jpg, *.png, *.pdf अनुमति दी गई है',
  'Upload Ministry of Tourism (GOI)': 'पर्यटन मंत्रालय (GOI) अपलोड करें',
  HGO: 'HGO',
  'Upload HGO': 'HGO अपलोड करें',
  PAN: 'पैन',
  'Upload PAN': 'पैन अपलोड करें',
  'Business PAN': 'व्यापार पैन',
  'Upload Business PAN': 'व्यापार पैन अपलोड करें',
  'GST Number': 'जीएसटी नंबर',
  'Upload GST Certificate': 'जीएसटी प्रमाणपत्र अपलोड करें',
  'GST Certificate': 'जीएसटी प्रमाणपत्र',
  'Package Name is required': 'पैकेज का नाम आवश्यक है',
  'Package Type is required': 'पैकेज प्रकार आवश्यक है',
  'Number of days is required': 'दिनों की संख्या आवश्यक है',
  'Number of days must be a positive number':
    'दिनों की संख्या सकारात्मक होनी चाहिए',
  'Number of days must be an integer': 'दिनों की संख्या पूर्णांक होनी चाहिए',
  'Room sharing is required': 'कमरे का साझा करना आवश्यक है',
  'Airline is required': 'एयरलाइन आवश्यक है',
  'Departure date is required': 'प्रस्थान तिथि आवश्यक है',
  'Return Date is required': 'वापसी तिथि आवश्यक है',
  'City is required': 'शहर आवश्यक है',
  'Package Amount is required': 'पैकेज राशि निर्धारित किया जाना चाहिए',
  'Package Amount must be a positive number': 'पैकेज राशि सकारात्मक होना चाहिए',
  'Business name is required': 'व्यापार का नाम आवश्यक है',
  'The username field is required': 'उपयोगकर्ता नाम क्षेत्र आवश्यक है',
  'The email provided should be a valid email address':
    'प्रदान किया गया ईमेल मान्य ईमेल पता होना चाहिए',
  'The email field is required': 'ईमेल फ़ील्ड आवश्यक है',
  'The password field is required': 'पासवर्ड फ़ील्ड आवश्यक है',
  'The url field is required': 'यूआरएल फ़ील्ड आवश्यक है',
  'The description field is required': 'विवरण फ़ील्ड आवश्यक है',
  'The position field is required': 'स्थिति फ़ील्ड आवश्यक है',
  'IATA License is required': 'IATA लाइसेंस आवश्यक है',
  'File Size is too large': 'फ़ाइल का आकार बहुत बड़ा है',
  'Ministry of Tourism is required': 'पर्यटन मंत्रालय आवश्यक है',
  'HGO is required': 'HGO आवश्यक है',
  'PAN is required': 'PAN आवश्यक है',
  'Pan Card number is not valid': 'पैन कार्ड नंबर मान्य नहीं है',
  'Business PAN is required': 'व्यापार पैन आवश्यक है',
  'Business Pan Card number is not valid':
    'व्यापार पैन कार्ड नंबर मान्य नहीं है',
  'GST number is not valid': 'GST नंबर मान्य नहीं है',
  'Pan Document is required': 'पैन दस्तावेज़ आवश्यक है',
  'Business Pan Document is required': 'व्यापार पैन दस्तावेज़ आवश्यक है',
  'GST Certificate Document is required': 'GST प्रमाणपत्र दस्तावेज़ आवश्यक है',
  'Unsupported Format': 'असमर्थित प्रारूप',
  'Search by business name, mobile number, email or registered at...':
    'व्यापार के नाम, मोबाइल नंबर, ईमेल या पंजीकृत पर खोजें...',
  'Registered At': 'पंजीकृत यहां',
  ALL: 'सभी',
  PENDING: 'बकाया',
  INPROCESS: 'प्रक्रिया में',
  COMPLETED: 'पूरा किया गया',
  REJECTED: 'अस्वीकृत',
  'Select city': 'शहर चुनें',
  'Select Role': 'भूमिका चुनें',
  Return: 'वापसी',
  'Hotel Details': 'होटल विवरण',
  Distance: 'दूरी',
  Location: 'स्थान',
  'Inclusions and Package Highlights': 'समावेश और पैकेज की विशेषताएं',
  Username: 'उपयोगकर्ता नाम',
  'Top Banner Position': 'शीर्ष बैनर स्थिति',
  'Bottom Banner Position': 'निचला बैनर स्थिति',
  'Upload image': 'फोटो अपलोड करें',
  'The mobile no. must be at most 10 digits':
    'मोबाइल नंबर अधिकतम 10 अंकों का होना चाहिए',
  'The mobile no. must be at least 10 digits':
    'मोबाइल नंबर कम से कम 10 अंकों का होना चाहिए',
  'The business name must be at most 50 characters':
    'व्यापार का नाम अधिकतम 50 अक्षरों का होना चाहिए',
  'The business name must be at least 1 character':
    'व्यापार का नाम कम से कम 1 अक्षर होना चाहिए',
  'The username must be at most 20 characters':
    'उपयोगकर्ता नाम अधिकतम 20 अक्षरों का होना चाहिए',
  'The email field must be at least 3 characters':
    'ईमेल क्षेत्र कम से कम 3 अक्षरों का होना चाहिए',
  'The email must be at most 320 characters':
    'ईमेल अधिकतम 320 अक्षरों का होना चाहिए',
  'The password must be at most 8 characters':
    'पासवर्ड अधिकतम 8 अक्षरों का होना चाहिए',
  'The password field must be at least 8 characters':
    'पासवर्ड क्षेत्र कम से कम 8 अक्षरों का होना चाहिए',
  'Package Name must be at least 4 characters':
    'पैकेज का नाम कम से कम 4 अक्षरों का होना चाहिए',
  'Package Name must be at most 255 characters':
    'पैकेज का नाम अधिकतम 255 अक्षरों का होना चाहिए',
  'Role name must be at least 1 character':
    'भूमिका का नाम कम से कम 1 अक्षर होना चाहिए',
  'Shortcode must be at most 5 characters':
    'शॉर्टकोड अधिकतम 5 अक्षरों का होना चाहिए',
  'Shortcode must be at least 1 character':
    'शॉर्टकोड कम से कम 1 अक्षर होना चाहिए',
  'Description must be at least 1 character':
    'विवरण कम से कम 1 अक्षर होना चाहिए',
  'Description must be at most 255 characters':
    'विवरण अधिकतम 255 अक्षरों का होना चाहिए',
  'Remark is required': 'टिप्पणी आवश्यक है',
  'Remark must be at least 4 characters':
    'टिप्पणी कम से कम 4 अक्षरों का होना चाहिए',
  'Remark must be at most 255 characters':
    'टिप्पणी अधिकतम 255 अक्षरों का होना चाहिए',
  'The name field must be at least 3 characters':
    'नाम क्षेत्र कम से कम 3 अक्षरों का होना चाहिए',
  'The name field must be at most 50 characters':
    'नाम क्षेत्र अधिकतम 50 अक्षरों का होना चाहिए',
  'The role field must be at least 1 characters':
    'भूमिका क्षेत्र कम से कम 1 अक्षर होना चाहिए',
  'Password must be 8 characters long': 'पासवर्ड 8 अक्षरों का होना चाहिए',
  'Password requires a number': 'पासवर्ड में एक संख्या की आवश्यकता है',
  'Password requires a lowercase letter':
    'पासवर्ड में एक छोटा अक्षर की आवश्यकता है',
  'Password requires an uppercase letter':
    'पासवर्ड में एक बड़ा अक्षर की आवश्यकता है',
  'Password requires a symbol': 'पासवर्ड में एक प्रतीक की आवश्यकता है',
  'The username field must be at least 3 characters':
    'उपयोगकर्ता नाम क्षेत्र कम से कम 3 अक्षरों का होना चाहिए',
  'The username field must be at most 20 characters':
    'उपयोगकर्ता नाम क्षेत्र अधिकतम 20 अक्षरों का होना चाहिए',
  'The first name field must be at least 3 characters':
    'पहला नाम क्षेत्र कम से कम 3 अक्षरों का होना चाहिए',
  'The first name field must be at most 25 characters':
    'पहला नाम क्षेत्र अधिकतम 25 अक्षरों का होना चाहिए',
  'The first name field is required': 'पहला नाम क्षेत्र आवश्यक है',
  'The last name field must be at least 3 characters':
    'अंतिम नाम क्षेत्र कम से कम 3 अक्षरों का होना चाहिए',
  'The last name field must be at most 25 characters':
    'अंतिम नाम क्षेत्र अधिकतम 25 अक्षरों का होना चाहिए',
  'The last name field is required': 'अंतिम नाम क्षेत्र आवश्यक है',
  'Pincode must be an integer': 'पिनकोड एक पूर्णांक होना चाहिए',
  'Pincode must be a positive number': 'पिनकोड एक सकारात्मक संख्या होना चाहिए',
  'Pincode is required': 'पिनकोड आवश्यक है',
  'Pincode must be a number': 'पिनकोड एक संख्या होना चाहिए',
  'Country is required': 'देश आवश्यक है',
  'State is required': 'राज्य आवश्यक है',
  'Landmark is required': 'संकेत स्थल आवश्यक है',
  'Area is required': 'क्षेत्र आवश्यक है',
  'Address is required': 'पता आवश्यक है',
  'Street Name is required': 'सड़क का नाम आवश्यक है',
  'Year of Establishment is required': 'स्थापना का वर्ष आवश्यक है',
  'Comment is required': 'टिप्पणी आवश्यक है',
  'Comment must be at least 1 character': 'टिप्पणी कम से कम 1 अक्षर होना चाहिए',
  'Comment must be at most 255 characters':
    'टिप्पणी अधिकतम 255 अक्षरों का होना चाहिए',
  'You must agree to our terms and conditions':
    'आपको हमारी नियम और शर्तों से सहमत होना होगा',
  'Email address': 'ईमेल पता',
  'User Name': 'उपयोगकर्ता नाम',
  'The mobile no. field is required': 'मोबाइल नंबर क्षेत्र आवश्यक है',
  'The name field is required': 'नाम क्षेत्र आवश्यक है',
  'Inactive Top Banners': 'निष्क्रिय शीर्ष बैनर',
  'Inactive Bottom Banners': 'निष्क्रिय निचले बैनर',
  'Mobile Image': 'मोबाइल छवि',
  'Desktop Image': 'डेस्कटॉप छवि',
  'Banner Created Date': 'बैनर बनाने की तारीख',
  'Banner Updated Date': 'बैनर अपडेट की तारीख',
  'Maximum number of active banners exceeded':
    'सक्रिय बैनरों की अधिकतम संख्या पार की गई',
  'Image dimension should be greater than 1000 X 1900 px':
    'छवि का आयाम 1000 X 1900 पिक्सेल से अधिक होना चाहिए',
  'Image dimension should be greater than 380 X 499 px':
    'छवि का आयाम 380 X 499 पिक्सेल से अधिक होना चाहिए',
  'Search by url...': 'यूआरएल द्वारा खोजें...',
  'Change Your Password': 'अपना पासवर्ड बदलें',
  'Enter your new password': 'अपना नया पासवर्ड दर्ज करें',
  Notifications: 'सूचनाएं',
  'Reset Password': 'पासवर्ड रीसेट करें',
  Profile: 'प्रोफ़ाइल',
  'Sign Out': 'साइन आउट',
  'Profile Under Review': 'प्रोफ़ाइल की समीक्षा के अधीन',
  'Review And Rating': 'समीक्षा और रेटिंग',
  'Review And Rating Management': 'समीक्षा और रेटिंग प्रबंधन',
  'Search by customer name,email,package name,vendor name...':
    'ग्राहक के नाम, ईमेल, पैकेज के नाम, विक्रेता के नाम से खोजें...',
  Content: 'सामग्री',
  'Content Management': 'सामग्री प्रबंधन',
  Preview: 'पूर्वावलोकन',
  Upload: 'अपलोड',
  Title: 'शीर्षक',
  'Top Banner Clicks Detail': 'शीर्ष बैनर क्लिक विवरण',
  'Bottom Banner Clicks Detail': 'नीचे के बैनर क्लिक विवरण',
  'Inactive Top Banner Clicks Detail': 'निष्क्रिय शीर्ष बैनर क्लिक विवरण',
  'Inactive Bottom Banner Clicks Detail': 'निष्क्रिय नीचे के बैनर क्लिक विवरण',
  'Clicks Detail': 'क्लिक विवरण',
  'Are you sure you want to Activate this content?':
    'क्या आप इस सामग्री को सक्रिय करना चाहते हैं?',
  'Are you sure you want to In-Activate this content?':
    'क्या आप इस सामग्री को निष्क्रिय करना चाहते हैं?',
  'Enter title': 'शीर्षक दर्ज करें',
  'Please enter content title': 'कृपया सामग्री का शीर्षक दर्ज करें',
  'Please enter description': 'कृपया विवरण दर्ज करें',
  'Please upload an image': 'कृपया एक छवि अपलोड करें',
  'FOOD RATING': 'खाद्य रेटिंग',
  'HOTEL RATING': 'होटल रेटिंग',
  'JIYARAT RATING': 'जियारत रेटिंग',
  COMMENTS: 'टिप्पणियाँ',
  'Search by title, subtitle and description...':
    'शीर्षक, उपशीर्षक और विवरण द्वारा खोजें...',
  'Sub Title': 'उपशीर्षक',
  'How to choose your tour packages?': 'अपने यात्रा पैकेज़ कैसे चुनें?',
  'How to apply for Haj?': 'हज के लिए कैसे आवेदन करें?',
  'Type of Hajj': 'हज के प्रकार',
  'Highest standards of professionalism, integrity, and personal service':
    'व्यावसायिकता, ईमानदारी और व्यक्तिगत सेवा की सर्वोच्च मानक',
  'Full co-ordination during your stay': 'आपके रहने के दौरान पूर्ण समन्वय',
  'Exclusive deals with leading Umrah service providers in Saudi Arabia':
    'सऊदी अरबिया में प्रमुख उमराह सेवा प्रदाताओं के साथ विशेष सौदे',
  Question: 'सवाल',
  Answer: 'उत्तर',
  Keyword: 'कीवर्ड',
  'Apply for Haj': 'हज के लिए आवेदन करें',
  'Type of Haj': 'हज के प्रकार',
  'Choose tour packages': 'यात्रा पैकेज़ चुनें',
  Standards: 'मानक',
  Stay: 'रहना',
  'Exclusive deals': 'विशेष सौदे',
  'The content has been updated': 'सामग्री अपडेट की गई है',
  'Record status has been updated': 'रिकॉर्ड की स्थिति अपडेट की गई है',
  "Couldn't update content status": 'सामग्री की स्थिति अपडेट नहीं की जा सकी',
  'The content saved successfully': 'सामग्री सफलतापूर्वक सहेजी गई है',
  'The content updated successfully': 'सामग्री सफलतापूर्वक अपडेट की गई है',
  'FAQ record deleted successfully': 'FAQ रिकॉर्ड सफलतापूर्वक हटाया गया',
  'An error occurred while updating FAQ': 'FAQ को अपडेट करते समय एक त्रुटि आई',
  'An error occurred while saving FAQ': 'FAQ सहेजते समय एक त्रुटि आई',
  'FAQ updated successfully': 'FAQ सफलतापूर्वक अपडेट किया गया',
  'FAQ saved successfully': 'FAQ सफलतापूर्वक सहेजा गया',
  'Spaces are not allowed': 'अंतर्यांत्रिक रूप स्वीकार्य नहीं हैं',
  'Record deleted successfully': 'रिकॉर्ड सफलतापूर्वक हटा दिया गया',
  'Content Pages': 'सामग्री पृष्ठ',
  'Content Sections': 'सामग्री खंड',
  'Tree View': 'वृक्ष दृश्य',
  'Search by page name or menu name...': 'पृष्ठ नाम या मेनू नाम से खोजें...',
  'Section Name': 'खंड का नाम',
  'Page Name': 'पृष्ठ का नाम',
  'Menu Name': 'मेनू का नाम',
  'View & Edit': 'देखें और संपादित करें',
  'Enter section name': 'खंड का नाम दर्ज करें',
  'Enter page name': 'पृष्ठ का नाम दर्ज करें',
  'Enter menu name': 'मेनू का नाम दर्ज करें',
  'Enter keyword': 'कीवर्ड दर्ज करें',
  'Add FAQ': 'सामान्य प्रश्न जोड़ें',
  'Update & Publish': 'अद्यतन और प्रकाशित करें',
  'Save & Publish': 'सहेजें और प्रकाशित करें',
  'The content field is required': 'सामग्री क्षेत्र आवश्यक है',
  'Icon dimension is not correct': 'प्रतिमा आयाम सही नहीं है',
  'Please select a PNG image': 'कृपया एक PNG चित्र चुनें',
  'Update Section Details': 'खंड विवरण अपडेट करें',
  'Add Section Details': 'खंड विवरण जोड़ें',
  Icon: 'प्रतिमा',
  'No file is selected': 'कोई फ़ाइल चयनित नहीं है',
  'Upload Icon': 'प्रतिमा अपलोड करें',
  'Minimum height and width should be 600 X 1000 pixel':
    'न्यूनतम ऊंचाई और चौड़ाई 600 X 1000 पिक्सेल होनी चाहिए',
  'Minimum height and width should be 800 X 1200 pixel':
    'न्यूनतम ऊंचाई और चौड़ाई 800 X 1200 पिक्सेल होनी चाहिए',
  'Upload image for Mobile': 'मोबाइल के लिए छवि अपलोड करें',
  'Upload image for Desktop': 'डेस्कटॉप के लिए छवि अपलोड करें',
  'Add Banner Details': 'बैनर विवरण जोड़ें',
  'Allowed *.jpeg, *.jpg, *.png, *.gif':
    '*.jpeg, *.jpg, *.png, *.gif की अनुमति है',
  'Allowed *.png': '*.png की अनुमति है',
  'Minimum height and width should be 32 X 32 pixel':
    'न्यूनतम ऊंचाई और चौड़ाई 32 X 32 पिक्सेल होनी चाहिए',
  'Mobile Image uploaded successfully': 'मोबाइल छवि सफलतापूर्वक अपलोड की गई',
  'Error while uploading an image': 'छवि अपलोड करते समय त्रुटि',
  'Desktop Image uploaded successfully': 'डेस्कटॉप छवि सफलतापूर्वक अपलोड की गई',
  'Icon uploaded successfully': 'प्रतिमा सफलतापूर्वक अपलोड की गई',
  'Error while uploading an icon': 'प्रतिमा अपलोड करते समय त्रुटि',
  'Currency status has been updated': 'मुद्रा स्थिति अपडेट कर दी गई है',
  'Could not update Currency status': 'मुद्रा स्थिति अपडेट नहीं की जा सकी',
  'The currency field must be at least 1 characters':
    'मुद्रा फ़ील्ड कम से कम 1 अक्षर का होना चाहिए',
  'The currency field is required': 'मुद्रा फ़ील्ड आवश्यक है',
  'The currency has been added sucessfuly': 'मुद्रा सफलतापूर्वक जोड़ दी गई है',
  'Currency Name': 'मुद्रा का नाम',
  'Available Currencies': 'उपलब्ध मुद्राएँ',
  'Complete Your Profile in Just a Few Easy Steps!':
    'कुछ आसान कदमों में अपना प्रोफ़ाइल पूरा करें!',
  'The admin will review your profile, and approval will be granted once the review process is complete.':
    'व्यवस्थापक आपकी प्रोफ़ाइल की समीक्षा करेंगे, और समीक्षा प्रक्रिया पूरी होने के बाद मंजूरी दी जाएगी।',
  'Your Profile Is Not Approved Yet': 'आपकी प्रोफ़ाइल अभी तक मंजूर नहीं है',
  "You can add your packages once your profile is complete. Click the 'Complete Profile' button to fill in the necessary details and start adding your packages.":
    "जब आपकी प्रोफ़ाइल पूरी हो जाए, तो आप अपने पैकेज जोड़ सकते हैं। आवश्यक विवरण भरने और अपने पैकेज जोड़ने के लिए 'पूरी प्रोफ़ाइल' बटन पर क्लिक करें।",
  "You can start adding your packages once your profile is approved. We'll notify you as soon as your profile is ready for package submissions. In the meantime, feel free to explore other features!":
    'जब आपकी प्रोफ़ाइल मंजूर हो जाए, तो आप अपने पैकेज जोड़ना शुरू कर सकते हैं। हम आपको सूचित करेंगे जैसे ही आपकी प्रोफ़ाइल पैकेज सबमिशन के लिए तैयार हो जाएगी। उस बीच, अन्य सुविधाओं का अन्वेषण करने का आनंद लें!',
  'Complete Profile': 'पूरी प्रोफ़ाइल',
  'If you make any edits to the details below, this package will be subject to review again. During this review period, this package will not be visible on the customer portal until it is approved again.':
    'यदि आप नीचे दिए गए विवरणों में कोई संपादन करते हैं, तो यह पैकेज फिर से समीक्षा के लिए उपलब्ध होगा। इस समीक्षा अवधि के दौरान, यह पैकेज पुनः मंजूर होने तक ग्राहक पोर्टल पर दिखाई नहीं देगा।',
  "If you make any edits to the details below, this vendor's profile will be subject to review again. During this review period, his/her packages will not be visible on the customer portal until his/her profile is approved.":
    'यदि आप नीचे दिए गए विवरणों में कोई संपादन करते हैं, तो इस वेंडर की प्रोफ़ाइल को फिर से समीक्षा के लिए उपलब्ध किया जाएगा। इस समीक्षा अवधि के दौरान, उसके पैकेज उसकी प्रोफ़ाइल मंजूर होने तक ग्राहक पोर्टल पर दिखाई नहीं देंगे।',
  'If you make any edits to the details below, your profile will be subject to review again. During this review period, your packages will not be visible on the customer portal until your profile is approved.':
    'यदि आप नीचे दिए गए विवरणों में कोई संपादन करते हैं, तो आपकी प्रोफ़ाइल को पुनः समीक्षा के लिए उपलब्ध किया जाएगा। इस समीक्षा अवधि के दौरान, आपके पैकेज आपकी प्रोफ़ाइल मंजूर होने तक ग्राहक पोर्टल पर दिखाई नहीं देंगे।',
  'Rejection Reason': 'अस्वीकृति का कारण',
  'Vendor Type': 'विक्रेता प्रकार',
  'Service Description': 'सेवा विवरण',
  'Service Description must be at least 1 character':
    'सेवा विवरण कम से कम 1 अक्षर होना चाहिए',
  'Service Description must be at most 255 characters':
    'सेवा विवरण अधिकतम 255 अक्षर होना चाहिए',
  'Service Description is required': 'सेवा विवरण आवश्यक है',
  'Business Description must be at least 1 character':
    'व्यावसायिक विवरण कम से कम 1 अक्षर होना चाहिए',
  'Business Description must be at most 255 characters':
    'व्यावसायिक विवरण अधिकतम 255 अक्षर होना चाहिए',
  'Business Description is required': 'व्यावसायिक विवरण आवश्यक है',
  'Review Profile': 'प्रोफ़ाइल की समीक्षा करें',
  'Already Rejected': 'पहले से ही अस्वीकृत',
  'Already Approved': 'पहले से ही स्वीकृत',
  Finish: 'समाप्त',
  'Update & Next': 'अपडेट और आगे',
  'Business TAN': 'व्यावसायिक टैन',
  Reject: 'अस्वीकृत करें',
  Approve: 'स्वीकृत करें',
  'Disable Edit': 'संपादन अक्षम करें',
  'REVIEW AND RATING': 'समीक्षा और रेटिंग',
  'Inquiry Status': 'पूछताछ की स्थिति',
  'Booking Status': 'बुकिंग स्थिति',
  Date: 'तारीख',
  Comment: 'टिप्पणी',
  'Package Lead': 'पैकेज लीड',

  'Are you sure you want to logout?':
    'क्या आप निश्चित हैं कि आप लोगआउट करना चाहते हैं?',
  Yes: 'हाँ',
  'Domain Name': 'डोमेन नाम',
  'Comment added and vendor rejected successfully':
    'टिप्पणी जोड़ी गई और विक्रेता को सफलतापूर्वक अस्वीकार किया गया',
  'Comment added and package rejected successfully':
    'टिप्पणी जोड़ी गई और पैकेज को सफलतापूर्वक अस्वीकृत किया गया',
  'The domain name must be at least 1 character':
    'डोमेन नाम कम से कम 1 अक्षर होना चाहिए',
  'The domain name must be at most 100 characters':
    'डोमेन नाम अधिकतम 100 अक्षर हो सकता है',
  'Only -, _, & characters are allowed and no spaces':
    'केवल -, _, और & वर्ण अनुमत हैं और कोई अंतरिक्ष नहीं हैं',
  'The domain name field is required': 'डोमेन नाम क्षेत्र आवश्यक है',
  'Domain name already exists': 'डोमेन नाम पहले से मौजूद है',
  'No Images Found': 'कोई छवियाँ नहीं मिलीं',
  "You can select a maximum of 5 images. Please deselect an image before selecting another if you've reached the limit.":
    'आप 5 छवियों का अधिकतम चयन कर सकते हैं। कृपया सीमा तक पहुँच जाने पर किसी अन्य छवि का चयन करने से पहले किसी छवि को अनचेक करें।',
  'Choose Any 5 Best Images': 'कोई भी 5 सर्वश्रेष्ठ छवियाँ चुनें',
  'Makkah Hotel Details': 'मक्का होटल विवरण',
  'Madinah Hotel Details': 'मदीना होटल विवरण',
  'Only JPEG, JPG, PNG, and PDF files are supported. Please upload a valid file.':
    'केवल JPEG, JPG, PNG और PDF फ़ाइलें समर्थित हैं। कृपया एक वैध फ़ाइल अपलोड करें.',
  'Only JPEG, JPG, PNG, and GIF files are supported. Please upload a valid file.':
    'केवल JPEG, JPG, PNG और GIF फ़ाइलें समर्थित हैं। कृपया एक वैध फ़ाइल अपलोड करें.',
  'Error while downloading file': 'फ़ाइल डाउनलोड करते समय त्रुटि',
  'File downloaded successfully': 'फ़ाइल सफलतापूर्वक डाउनलोड हो गई',
  'File size exceeds the maximum limit of 2MB.':
    'फ़ाइल का आकार 2MB की अधिकतम सीमा से अधिक है',
  'Location Master': 'स्थान मास्टर',
  'Add Location': 'स्थान जोड़ें',
  'Update Location': 'स्थान अपडेट करें',
  'City Name': 'शहर का नाम',
  'State Name': 'राज्य का नाम',
  'Country Name': 'देश का नाम',
  'City Image': 'शहर की छवि',
  'Select Image': 'छवि चुनें',
  'Location added successfully': 'स्थान सफलतापूर्वक जोड़ा गया',
  'Location updated successfully': 'स्थान सफलतापूर्वक अपडेट किया गया',
  'Status updated successfully': 'स्थिति सफलतापूर्वक अपडेट की गई',
  'Failed to update status': 'स्थिति अपडेट करने में विफल',
  'Search by country or city...': 'देश या शहर से खोजें...',
  'No locations found': 'कोई स्थान नहीं मिला',
  'State Name (Optional)': 'राज्य का नाम (वैकल्पिक)',
  'Default State': 'डिफ़ॉल्ट राज्य'
};

export default hnJSON;
